import { createSlice } from "@reduxjs/toolkit";
import { matterboardList } from "./matterboardAsyncThunk";

const matterboardListSlice = createSlice({
  name: "matterboard",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [matterboardList.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [matterboardList.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [matterboardList.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default matterboardListSlice.reducer;
